import { Capacitor } from "@capacitor/core";
import { Modal } from "antd";
import { svg } from "../../../../../Assets/svg";
import CapacitorPdfViewer from "../../../../../Components/CapacitorPdfViewer";

interface Props {
  open: boolean;
  pdfData: any;
  onClose: () => void;
}

const ViewPdfModal = ({ open, onClose, pdfData }: Props) => {
  const pdfTitle = pdfData?.title || "View PDF";

  if (Capacitor.isNativePlatform()) {
    return (
      <CapacitorPdfViewer
        isOpen={open}
        onClose={onClose}
        pdfBlob={pdfData?.blob}
        title={pdfTitle}
        fileName={`${pdfTitle}.pdf`}
      />
    );
  }

  const rawUrl = typeof pdfData === "string" ? pdfData : pdfData?.url || "";
  const pdfUrl = rawUrl && !rawUrl.includes("#") ? `${rawUrl}#view=FitH` : rawUrl;

  return (
    <Modal
      open={open}
      centered
      width={"88.75rem"}
      footer={null}
      onCancel={onClose}
      closeIcon={svg?.closeIcon}
      title={<div className="text-center fs-4 fw-bolder lh-m">{pdfTitle}</div>}
      className="custom-modal load-notice-pdf"
      styles={{ body: { padding: 0 } }}
    >
      <iframe
        src={pdfUrl}
        style={{
          border: "none",
          display: "block",
          width: "100%",
          height: "100%",
          minHeight: "calc(100vh - 5rem)",
        }}
        title="PDF Preview"
      />
    </Modal>
  );
};

export default ViewPdfModal;
